import { updateGrowthItem } from '../../commonLogic';
import * as Constants from '../action_types/EPAConstants.js';
import { getGatewayandControllerHost, validateDriveChange } from '../../commonLogic.js';

const initialState = {
  guiState: {
    updateManagementDetails: false,
    computeHostChanged: false,
    GandCAPICount: 0,
    displayWarning: false,
    currentTabActiveIndex: 1,
  },
  getExtraNodes: false,
  calculateBlueDataAPIcount: 0,
  workload: {},
  sizerWorkloadforCalculation: {
    value: {}
  },
  nonGPUOldWorkload: {},
  GPUOldWorkload: {},
  StorageOldWorkload: {},
  sessionDefaults: null,
  supportedList: null,
  isLoading: false,
  isLoadingServers: false,
  isCal: false,
  currentTab: '',
  changeGateway: false,
  calculateWithUpdatedTenantDrive: false,
  currentRoleName: '',
  activepartnumbers: null,
  filteredComponents: null,
  ServicesChanged: { val: false },
  isWaiting: false,
  ComputeCheckbox: { val: false },
  serversList: [],
  Templates: null,
  GPUQty: '2',
  ServicesInput: '',
  ErasureCodingChkd: false,
  StorageCapacitytype: { HDFS: '', MAPR: '' },
  EPICRequirements: null,
  BlueDataCal: null,
  Gatewaydetails: null,
  Controllerdetails: null,
  Masterdetails: null,
  Storagedetails: null,
  GPUdetails: null,
  NonGPUdetails: null,
  MasterQTY: null,
  GatewayQty: null,
  calbtn: false,
  duplicateOSlist: [],
  Indexes: {
    functions: 0,
    extraConfiguration: 0
  },
  prevValues: {
    MasterQTY: '',
    GatewayQty: ''
  },
  bluedataOsDisk:
    { validate: false },
  HostCount: {
    GPUHostCount: 0,
    NonGPUHostCount: 0,
    StorageHostCount: 0,
  },
  GPUValue: {
    TotalVMemory: '',
    TotalCore: '',
    TotalStorage: '',
    Server: '',
    Proc: '',
    Memory: '',
    Drive: '',
    DriveQty: '',
    ServerQty: '',
    isCalculated: 'false'
    // GPUcountperserver:''
  },
  NonGPUValue: {
    TotalVMemory: '',
    TotalCore: '',
    TotalStorage: '',
    Server: '',
    Proc: '',
    Memory: '',
    Drive: '',
    DriveQty: '',
    ServerQty: '',
    isCalculated: 'false'
  },
  StorageValue: {
    TotalVMemory: '',
    TotalCore: '',
    TotalStorage: '',
    Server: '',
    Proc: '',
    Memory: '',
    Drive: '',
    DriveQty: '',
    ServerQty: '',
    isCalculated: 'false'
  },
  ControllerConfigChanged: false,
  count: 0,
  isError: false,
  Errormsg: '',
  iterationCount: 1,
  strmessage: '',
  title: { value: "HDFS" },
  scrollsetting: { val: true },
}

const HPEAPOLLO4200GEN10SERVER = "HPE Apollo 4200 Gen10 Server";
const PROLIANTXL170RGEN10 = "ProLiant XL170r Gen10";
const HPMOONSHOTSYSTEM = "HP Moonshot System";
const ZERO_ = "0";
const ATTRIBUTE_NAME = "@Name";
const ATTRIBUTE_NODEDISK = "@NodeDisk";
const ATTRIBUTE_TSTORAGEDRIVE = "@TStorageDrive";
const ATTRIBUTE_OSDISK = "@OSDisk";

const updateGateWayDetails = (state) => {
  state.workload.UserInputs.Environments.ManagementHosts.Server.map(host => {
    let serverName = getGatewayandControllerHost(state.workload, host["@Type"]);
    if (serverName === HPEAPOLLO4200GEN10SERVER) {
      host["@Name"] = PROLIANTXL170RGEN10;
    }
    else {
      host["@Name"] = serverName
    }
    if (host["@Name"].indexOf(Constants.MOONSHOT_510) === -1 && host["@Name"].indexOf(Constants.E910) === -1) {
      host["@ServerName"] = host["@Name"];
    }
    else {
      host["@ServerName"] = HPMOONSHOTSYSTEM;
    }
  })
  state.guiState.updateManagementDetails = true;
  state.guiState.computeHostChanged = false;
}

const updateGatewayandController = (state, action, hostType) => {
  if (action.payload) {
    let commomObject = state.workload.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === hostType);
    if (action.payload["ProcFamily"]) {
      commomObject["@ProcFamily"] = action.payload["ProcFamily"];
    }
    if (action.payload["Processor"]) {
      commomObject["@Proc"] = action.payload["Processor"];
    }
    if (action.payload["Memory"]) {
      commomObject["@Memory"] = action.payload["Memory"];
    }
    if (action.payload["NodeStorageDrive"]) {
      commomObject["@NodeDisk"] = action.payload["NodeStorageDrive"];
    }
    if (hostType === Constants.CONTROLLER_) {
      if (action.payload["PersistentDrive"]) {
        commomObject["@TStorageDrive"] = action.payload["PersistentDrive"];
      }
      if (action.payload[Constants.ATTRIBUTE_PERSISTENTDRIVEQTY] !== undefined) {
        commomObject["@TStorageDriveQty"] = action.payload[Constants.ATTRIBUTE_PERSISTENTDRIVEQTY];
      }
      let CAASSolution = state.workload.UserInputs.Environments.Environment.find(solution => solution["@SolutionType"] === Constants.CAAS_);
      if (CAASSolution) {
        if (CAASSolution["@isSelected"] === Constants.yES_) {
          commomObject["@Memory"] = Constants.CAAS_MEMORY;
        }
      }
    }
    if (hostType === Constants.MASTER_) {
      if (action.payload["PersistentDrive"]) {
        commomObject["@TStorageDrive"] = action.payload["PersistentDrive"];
      }
      if (action.payload[Constants.ATTRIBUTE_PERSISTENTDRIVEQTY] !== undefined) {
        commomObject["@TStorageDriveQty"] = action.payload[Constants.ATTRIBUTE_PERSISTENTDRIVEQTY];
      }
      let CAASSolution = state.workload.UserInputs.Environments.Environment.find(solution => solution["@SolutionType"] === Constants.CAAS_);
      if (CAASSolution) {
        if (CAASSolution["@isSelected"] === Constants.yES_) {
          commomObject["@Memory"] = Constants.CAAS_MEMORY;
        }
      }
    }
    if (action.payload["NodeDriveQty"]) {
      commomObject["@StorageDiskQty"] = action.payload["NodeDriveQty"];
    }
    if (hostType === Constants.GATEWAY_) {
      if (commomObject["@Name"] === Constants.SYN_480_GEN10) {
        commomObject["@StorageDiskQty"] = ZERO_;
      }
    }
    if (action.payload[Constants.ATTRIBUTE_OSDRIVE]) {
      commomObject["@OSDisk"] = action.payload[Constants.ATTRIBUTE_OSDRIVE];
    } else {
      let osDriveList = []
      if (hostType === Constants.GATEWAY_) {
        osDriveList = state.Gatewaydetails[commomObject[ATTRIBUTE_NAME]].OSDriveList;
      } else if (hostType === Constants.CONTROLLER_) {
        osDriveList = state.Controllerdetails[commomObject[ATTRIBUTE_NAME]].OSDriveList;
      } else if (hostType === Constants.MASTER_) {
        osDriveList = state.Masterdetails[commomObject[ATTRIBUTE_NAME]].OSDriveList;
      }
      const updateOSDrive = () => {
        let isValidCombination = false;
        for (const item of osDriveList) {
          if (!isValidCombination) {
            if (validateDriveChange(commomObject[ATTRIBUTE_NODEDISK], commomObject[ATTRIBUTE_TSTORAGEDRIVE], item, commomObject[ATTRIBUTE_NAME])) {
              isValidCombination = true;
              commomObject[ATTRIBUTE_OSDISK] = item;
            }
          }
        }
      }
      if (osDriveList.indexOf(commomObject[ATTRIBUTE_OSDISK]) === -1) {
        updateOSDrive();
      } else {
        if (!validateDriveChange(commomObject[ATTRIBUTE_NODEDISK], commomObject[ATTRIBUTE_TSTORAGEDRIVE], commomObject[ATTRIBUTE_OSDISK], commomObject[ATTRIBUTE_NAME])) {
          updateOSDrive();
        }
      }
    }
  }
  state.guiState.GandCAPICount -= 1;
  let loadinglayer = true;
  if (state.guiState.GandCAPICount === 0) {
    loadinglayer = false;
  }
  return loadinglayer;
}

const updatePersistentDriveArray = (roleType, role, action, key) => {
  if (roleType === Constants.STORAGE_ && action.payload[key]['lstHDFSDrives'].length > 0) {
    role.PersistentDisks = [];
    action.payload[key][Constants.LST_HDFS_DRIVES].map(drive => {
      let newDrive = {
        Item: {
          "@size": drive[Constants.DDRIVE_SIZE],
          "@disk": drive[Constants.STR_DRIVE],
          "@qty": drive[Constants.I_QTY],
          "@volumeName": Constants.PERSISTENT_,
        }
      }
      role.PersistentDisks.push(newDrive);
    })
  }
}

const updateGPUsCount = (action, templateType, key, currentTabObject) => {
  if (action.payload[key]['dTotalGPUs']) {
    if (currentTabObject["@SolutionType"] === Constants.MLOPS) {
      let actionTemplate = currentTabObject.Templates.Template.find(template => template["@Type"] === templateType && template["@InputMode"] === Constants.IMAGE_PROCESSING)
      if (actionTemplate) {
        actionTemplate.Nodes["@GPUs"] = action.payload[key]['dTotalGPUs'];
      }
    }
  }
}
const sizerWorkload = (state = initialState, action) => {

  let temp;
  let type = '';
  let workloadtemp = '';
  let GPUvaluetemp = '';
  let NonGPUvaluetemp = '';
  let StorageValuetemp = '';
  let Errormsgtemp = '';
  let isErrortemp = '';
  let shouldChangegateway = false;
  let calculateBlueDataAPIcount;
  let servicetemp = '';
  switch (action.type) {

    case 'ITERATION_INCREASE':
      return Object.assign({}, state, {
        iterationCount: action.payload,

      });
    case 'FETCH_DEFAULT_DATA_SUCCESS123':
      return Object.assign({}, state, {
        workload: JSON.parse(JSON.stringify(action.payload)),

      });

    case 'UPDATE_SIZER_WORKLOAD':
      return Object.assign({}, state, {
        workload: JSON.parse(JSON.stringify(action.payload))
      });

    case 'UPDATE_SESSION_DEFAULTS':
      return Object.assign({}, state, {
        sessionDefaults: action.payload
      });

    case 'EPA_FETCH_SUPPORTEDLIST_PENDING':
      return Object.assign({}, state, {
        isLoading: true
      });

    case 'EPA_FETCH_SUPPORTEDLIST_SUCCESS':
      temp = state.isWaiting;
      return Object.assign({}, state, {
        supportedList: action.payload,
        isLoading: temp
      });

    case 'EPA_FETCH_SUPPORTEDLIST_ERROR':
      temp = state.isWaiting;
      return Object.assign({}, state, {
        isLoading: temp
      });

    case 'EPA_FETCH_ACTIVEPARTNUMBERS_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        isWaiting: true
      });

    case 'EPA_FETCH_ACTIVEPARTNUMBERS_SUCCESS':
      return Object.assign({}, state, {
        activepartnumbers: action.payload,
        isLoading: false,
        isWaiting: false
      });

    case 'EPA_FETCH_ACTIVEPARTNUMBERS_ERROR':
      return Object.assign({}, state, {
        isLoading: false,
        isWaiting: false
      });
    case 'FILTERED_COMPONENTS':
      return Object.assign({}, state, {
        filteredComponents: action.payload.data,
      });

    case 'FETCH_DEFAULT_WRKLD_SUCCESS':
      return Object.assign({}, state, {
        // serversList:JSON.parse(JSON.stringify(action.payload)),
        //workload:JSON.parse(JSON.stringify(action.payload.workload)),
        ServicesInput: JSON.parse(JSON.stringify(action.payload.input)),
        // sessionDefaults:JSON.parse(JSON.stringify(action.payload.input)),
        isLoading: false
      });
    case 'FETCH_DEFAULT_WRKLD_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        //isWaiting:false
      });
    case 'SERVER_LIST_SUCCESS':
      let serversList = ""
      if (action.payload.filter(x => x['functionName'] === "Gateway Node")[0] === undefined || state.serversList.filter(x => x['functionName'] === 'Gateway Node')[0] === undefined) {
        serversList = state.serversList.concat(action.payload)
      } else {
        serversList = state.serversList
      }

      return Object.assign({}, state, {
        serversList: serversList,
        isLoadingServers: false
      });

    case 'SERVER_LIST_PENDING':
      return Object.assign({}, state, {
        isLoadingServers: true,
      })
    case 'FETCH_NODEQTY_SUCCESS':
      state.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        if (val['@Type'] === action.payload.function) {
          if (Array.isArray(val.Service)) {
            val.Service.filter((service) => {
              if (service['@Type'] === action.payload.service) {
                if (action.payload.service === Constants.DATA_LAKE && state.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric['@IsSelected'] === Constants.tRUE_) {
                  if (parseInt(action.payload.qty, 10) < parseInt(Constants.DATALAKE_MIN_NODES, 10)) {
                    action.payload.qty = Constants.DATALAKE_MIN_NODES;
                    state.workload.UserInputs.Environments.isDataLakeNodeCountUpdated = Constants.fALSE_;
                    state.workload.UserInputs.Environments.DataLakeNodeCount = action.payload.qty;
                    state.workload.UserInputs.Environments.updateDataLakeRecommendations = Constants.fALSE_;
                  }
                }
                service.Hardware['@NodesCount'] = action.payload.qty;
                updateGrowthItem(action.payload.service, action.payload.qty, state.workload);
                if (action.payload.service === "Weka") {
                  service.Hardware['@DataDisk'] = action.payload.strDisk;
                  service.Hardware['@DiskQty'] = action.payload.iDiskQty;
                  service.Inputs['@RawCapacity'] = action.payload.dRawCapacity;
                }
                if (action.payload.function === "AI") {
                  service.Inputs['@GPUQty'] = action.payload.gpuQty;
                }
                if (action.payload.function === "Analytics" || action.payload.function === "Database") {
                  if (service["@mixedStorage"] !== "True") {
                    if (action.payload.datadisk !== '') {
                      service.Hardware['@DataDisk'] = action.payload.datadisk;
                    }
                    if (action.payload.datadiskqty !== '' && action.payload.datadisk !== '') {
                      service.Hardware['@DiskQty'] = action.payload.datadiskqty;
                    }
                  }
                }
              }
            });
          }
        }
      });
      /* Changes by Vinay, Same code is being executed irrespective of condition. for CID:10011*/
      /*if( state.workload.UserInputs.Environments.strmessage ===undefined)
      {*/
      if (action.payload.service === "Hive") {
        state.workload.UserInputs.Environments.strmessage = action.payload.strmessage
      }
      /*}else{ 
        if (action.payload.service === "Hive") {
          state.workload.UserInputs.Environments.strmessage=action.payload.strmessage
        }
      }*/
      servicetemp = state.workload;
      return Object.assign({}, state, {
        isLoading: false,
        getExtraNodes: true,
        workload: servicetemp,
        GPUQty: action.payload.gpuQty,
        // strmessage:action.payload.strmessage
      });

    case 'FETCH_NODEQTY_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
        //serversList: state.serversList.concat(action.payload)          
      });
    case 'FETCH_NODEQTY_ERROR':
      return Object.assign({}, state, {
        isLoading: false,
      });
    case 'SERVER_ERROR':
      return Object.assign({}, state, {
        isLoading: false,
      });
    case 'ARCVALUE_SUCCESS':
      let ARCtemp = '';
      state.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        if (val['@Type'] === "Storage") {
          if (Array.isArray(val.Service)) {
            val.Service.filter((service) => {
              if (service['@Type'] === "Scality") {
                service.Inputs['@ARC'] = action.payload;
              }
            });
          }
        }
      });
      ARCtemp = state.workload;
      return Object.assign({}, state, {
        workload: ARCtemp,
        //isLoading:false
      });
    case 'ARCVALUE_PENDING':
      return Object.assign({}, state, {
        // isLoading:true                     
      });
    case 'OSLISTBLUEDATA_SUCCESS':

      if (action.payload.rolename === "NONGPU") {
        let oslisttemp1 = state.workload;
        let NonGPUtemp = state.NonGPUdetails;
        NonGPUtemp[action.payload.Server].OSDriveList = action.payload.osList;
        if (action.payload.osList.indexOf(oslisttemp1.UserInputs.Environments.Environment.find(Solution => Solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.NONGPU_)["@OSDisk"]) === -1) {
          oslisttemp1.UserInputs.Environments.Environment.find(Solution => Solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.NONGPU_)["@OSDisk"] = action.payload.osList[0];
        }

        let temp_bluedataOsDisk = state.bluedataOsDisk;
        temp_bluedataOsDisk.validate = true;
        return Object.assign({}, state, {
          NonGPUdetails: NonGPUtemp,
          workload: oslisttemp1,
          isLoading: false,
          bluedataOsDisk: temp_bluedataOsDisk
        });
      }
      else if (action.payload.rolename === "GPU") {
        let oslisttemp1 = state.workload;
        let GPUtemp = state.GPUdetails;
        GPUtemp[action.payload.Server].OSDriveList = action.payload.osList;
        if (action.payload.osList.indexOf(oslisttemp1.UserInputs.Environments.Environment.find(Solution => Solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.GPU_)["@OSDisk"]) === -1) {
          oslisttemp1.UserInputs.Environments.Environment.find(Solution => Solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.GPU_)["@OSDisk"] = action.payload.osList[0];
        }
        //oslisttemp1.UserInputs.Environments.Templates.ServerDetails.Server[1]["@OSDisk"] = action.payload.osList[0];
        let temp_bluedataOsDisk = state.bluedataOsDisk;
        temp_bluedataOsDisk.validate = true;
        return Object.assign({}, state, {
          GPUdetails: GPUtemp,
          workload: oslisttemp1,
          isLoading: false,
          bluedataOsDisk: temp_bluedataOsDisk
        });
      }
      else if (action.payload.rolename === Constants.STORAGE_) {
        let oslisttemp1 = state.workload;
        let Storagetemp = state.Storagedetails;
        Storagetemp[action.payload.Server].OSDriveList = action.payload.osList;
        if (action.payload.osList.indexOf(oslisttemp1.UserInputs.Environments.Environment.find(Solution => Solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.STORAGE_)["@OSDisk"]) === -1) {
          oslisttemp1.UserInputs.Environments.Environment.find(Solution => Solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.STORAGE_)["@OSDisk"] = action.payload.osList[0];
        }
        return Object.assign({}, state, {
          Storagedetails: Storagetemp,
          workload: oslisttemp1,
          isLoading: false,
        })
      }
      else if (action.payload.rolename === "Gateway") {
        let oslisttemp1 = state.workload;
        let gateWaytemp = state.Gatewaydetails;
        gateWaytemp[action.payload.Server].OSDriveList = action.payload.osList;
        if (action.payload.osList.indexOf(oslisttemp1.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.GATEWAY_)["@OSDisk"]) === -1) {
          oslisttemp1.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.GATEWAY_)["@OSDisk"] = action.payload.osList[0];
        }
        //oslisttemp1.UserInputs.Environments.Templates.ServerDetails.Server[2]["@OSDisk"] = action.payload.osList[0];
        let temp_bluedataOsDisk = state.bluedataOsDisk;
        temp_bluedataOsDisk.validate = true;
        return Object.assign({}, state, {
          Gatewaydetails: gateWaytemp,
          workload: oslisttemp1,
          isLoading: false,
          bluedataOsDisk: temp_bluedataOsDisk
        });
      }
      else if (action.payload.rolename === "Controller") {
        let oslisttemp1 = state.workload;
        let gateWaytemp = state.Controllerdetails;
        gateWaytemp[action.payload.Server].OSDriveList = action.payload.osList;
        if (action.payload.osList.indexOf(oslisttemp1.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@OSDisk"]) === -1) {
          oslisttemp1.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@OSDisk"] = action.payload.osList[0];
        }
        // oslisttemp1.UserInputs.Environments.Templates.ServerDetails.Server[3]["@OSDisk"] = action.payload.osList[0];
        let temp_bluedataOsDisk = state.bluedataOsDisk;
        temp_bluedataOsDisk.validate = true;
        return Object.assign({}, state, {
          Controllerdetails: gateWaytemp,
          workload: oslisttemp1,
          isLoading: false,
          bluedataOsDisk: temp_bluedataOsDisk
        });
      }
      else if (action.payload.rolename === "Master") {
        let oslisttemp1 = state.workload;
        let gateWaytemp = state.Masterdetails;
        gateWaytemp[action.payload.Server].OSDriveList = action.payload.osList;
        if (action.payload.osList.indexOf(oslisttemp1.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.MASTER_)["@OSDisk"]) === -1) {
          oslisttemp1.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.MASTER_)["@OSDisk"] = action.payload.osList[0];
        }
        // oslisttemp1.UserInputs.Environments.Templates.ServerDetails.Server[3]["@OSDisk"] = action.payload.osList[0];
        let temp_bluedataOsDisk = state.bluedataOsDisk;
        temp_bluedataOsDisk.validate = true;
        return Object.assign({}, state, {
          Masterdetails: gateWaytemp,
          workload: oslisttemp1,
          isLoading: false,
          bluedataOsDisk: temp_bluedataOsDisk
        });
      }

    case 'OSLISTBLUEDATA_PENDING':
      //  let ostemp;
      // ostemp=state.count+1;
      return Object.assign({}, state, {
        isLoading: true,
        // count:ostemp
      });

    case 'TENANTDRIVELIST_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
      });

    case 'TENANTDRIVELIST_SUCCESS':
      let toBeRecalculted = false;
      let roleType = ""
      if (action.payload.rolename === "NONGPU") {
        let oslisttemp1 = state.workload;
        let NonGPUtemp = state.NonGPUdetails;
        NonGPUtemp[action.payload.Server].TenantDriveList = action.payload.osList;
        if (action.payload.osList.indexOf(oslisttemp1.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.NONGPU_)["@TStorageDrive"]) === -1) {
          oslisttemp1.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.NONGPU_)["@TStorageDrive"] = action.payload.osList[0];
          toBeRecalculted = true;
          roleType = action.payload.rolename
        }
        return Object.assign({}, state, {
          NonGPUdetails: NonGPUtemp,
          workload: oslisttemp1,
          isLoading: false,
          calculateWithUpdatedTenantDrive: toBeRecalculted,
          currentRoleName: roleType
        });
      }
      else if (action.payload.rolename === "GPU") {
        let oslisttemp1 = state.workload;
        let GPUtemp = state.GPUdetails;
        GPUtemp[action.payload.Server].TenantDriveList = action.payload.osList;
        if (action.payload.osList.indexOf(oslisttemp1.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Server.find(role => role["@Type"] === Constants.GPU_)["@TStorageDrive"]) === -1) {
          oslisttemp1.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetailsServer.find(role => role["@Type"] === Constants.GPU_)["@TStorageDrive"] = action.payload.osList[0];
          toBeRecalculted = true;
          roleType = action.payload.rolename;
        }
        return Object.assign({}, state, {
          GPUdetails: GPUtemp,
          workload: oslisttemp1,
          isLoading: false,
          calculateWithUpdatedTenantDrive: toBeRecalculted,
          currentRoleName: roleType
        });
      }
      else if (action.payload.rolename === "Controller") {
        let oslisttemp1 = state.workload;
        let gateWaytemp = state.Controllerdetails;
        gateWaytemp[action.payload.Server].TenantDriveList = action.payload.osList;
        if (action.payload.osList.indexOf(oslisttemp1.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@TStorageDrive"]) === -1) {
          oslisttemp1.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.CONTROLLER_)["@TStorageDrive"] = action.payload.osList[0];
        }
        return Object.assign({}, state, {
          Controllerdetails: gateWaytemp,
          workload: oslisttemp1,
          isLoading: false,
        });
      }
      else if (action.payload.rolename === "Master") {
        let oslisttemp1 = state.workload;
        let gateWaytemp = state.Masterdetails;
        gateWaytemp[action.payload.Server].TenantDriveList = action.payload.osList;
        if (action.payload.osList.indexOf(oslisttemp1.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.MASTER_)["@TStorageDrive"]) === -1) {
          oslisttemp1.UserInputs.Environments.ManagementHosts.Server.find(role => role["@Type"] === Constants.MASTER_)["@TStorageDrive"] = action.payload.osList[0];
        }
        return Object.assign({}, state, {
          Masterdetails: gateWaytemp,
          workload: oslisttemp1,
          isLoading: false,
        });
      }

    case 'OSLIST_SUCCESS':
      let Oslisttemp = '';
      let duplicateOSlisttemp = []
      state.serversList.filter((val) => {
        if (val['functionName'] === action.payload.Function) {
          if (val['serviceName'] === action.payload.Service) {
            for (let key in val.totalList) {
              if (key === action.payload.Server) {
                val.totalList[key].OSDiskList = action.payload.osList

              }
            }

          }
        }
      });
      duplicateOSlisttemp = action.payload.osList
      Oslisttemp = state.workload;
      return Object.assign({}, state, {
        duplicateOSlist: duplicateOSlisttemp,
        workload: Oslisttemp,
        isLoading: false,

      });
    case 'OSLIST_PENDING':
      return Object.assign({}, state, {
        isLoading: true,
      });
    case 'EPAVNEXT_FETCH_TEMPLATELIST_SUCCESS':
      let resulttlisttemp = true;
      let rst = state.count - 1
      if (state.count - 1 === 0) {
        resulttlisttemp = false
      }
      return Object.assign({}, state, {
        Templates: action.payload,
        isLoading: resulttlisttemp,
        count: rst
      });
    case 'EPAVNEXT_FETCH_TEMPLATELIST_PENDING':
      let tlisttemp;
      tlisttemp = state.count + 1;
      return Object.assign({}, state, {
        isLoading: true,
        count: tlisttemp
      });
    case 'EPICREQUIREMENTS_SUCCESS':
      let epictemprst = true;
      let epictempcount = state.count - 1
      if (state.count - 1 === 0) {
        epictemprst = false
      }
      calculateBlueDataAPIcount = state.calculateBlueDataAPIcount - 1
      return Object.assign({}, state, {
        EPICRequirements: action.payload,
        isLoading: epictemprst,
        count: epictempcount,
        calculateBlueDataAPIcount: calculateBlueDataAPIcount
      });
    case 'EPICREQUIREMENTS_PENDING':
      let epictemp;
      epictemp = state.count + 1;
      return Object.assign({}, state, {
        isLoading: true,
        count: epictemp
      });
    case 'CALCULATEBLUEDATACONFIG_SUCCESS':
      let currentTabObject = state.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_);
      currentTabObject.NonGPUValue.isCalculated = Constants.fALSE_;
      currentTabObject.GPUValue.isCalculated = Constants.fALSE_;
      currentTabObject.StorageValue.isCalculated = Constants.fALSE_;
      if (currentTabObject.Templates.Template.filter(x => x["@Type"].indexOf(Constants.INFERENCE_) > -1 && x.Nodes["@ImagesPerSec"] > 0).length > 0 && currentTabObject.Templates.Template.filter(x => x["@Type"].indexOf(Constants.INFERENCE_) === -1 && x["@Type"].indexOf(Constants.GPU_) > -1).length === 0) {
        for (let key in action.payload) {
          if (key === Constants.GPU_RESULT) {
            if (!action.payload[Constants.NONGPU_RESULT]) {
              action.payload[Constants.NONGPU_RESULT] = action.payload[Constants.GPU_RESULT];
              delete action.payload[Constants.GPU_RESULT];
            }
          }
        }
      }
      currentTabObject.Templates.ServerDetails.Server.filter((val) => {
        for (let key in action.payload) {
          if (key === "NonGPU_Result") {
            type = Constants.NONGPU_
            currentTabObject.NonGPUValue.TotalVMemory = action.payload[key]['d_TotalVMemory']
            currentTabObject.NonGPUValue.TotalCore = action.payload[key]['d_TotalVCPU']
            currentTabObject.NonGPUValue.TotalStorage = action.payload[key]['d_TotalStorage']
            updateGPUsCount(action, Constants.INFERENCE_, key, currentTabObject);
            if (action.payload[key]['ErrorMsg'] === null || action.payload[key]['ErrorMsg'] === "" || action.payload[key]['ErrorMsg'] === undefined) {
              currentTabObject.NonGPUValue.isCalculated = Constants.tRUE_;
            }
          } else if (key === "GPU_Result") {
            type = Constants.GPU_
            currentTabObject.GPUValue.TotalVMemory = action.payload[key]['d_TotalVMemory']
            currentTabObject.GPUValue.TotalCore = action.payload[key]['d_TotalVCPU']
            currentTabObject.GPUValue.TotalStorage = action.payload[key]['d_TotalStorage']
            updateGPUsCount(action, Constants.TRAINING, key, currentTabObject);
            if (action.payload[key]['ErrorMsg'] === null || action.payload[key]['ErrorMsg'] === "" || action.payload[key]['ErrorMsg'] === undefined) {
              currentTabObject.GPUValue.isCalculated = Constants.tRUE_;
            }
            //  state. GPUValue.GPUcountperserver=action.payload[key]['RecommendedGPUQty']
          } else if (key === Constants.STORAGE_) {
            type = Constants.STORAGE_;
            currentTabObject.StorageValue.TotalVMemory = action.payload[key]['d_TotalVMemory'];
            currentTabObject.StorageValue.TotalCore = action.payload[key]['d_TotalVCPU'];
            currentTabObject.StorageValue.TotalStorage = action.payload[key]['d_TotalStorage'];
            if (action.payload[key]['ErrorMsg'] === null || action.payload[key]['ErrorMsg'] === "" || action.payload[key]['ErrorMsg'] === undefined) {
              currentTabObject.StorageValue.isCalculated = Constants.tRUE_;
            }
          }

          if (val['@Type'] === type) {
            if (action.payload[key]['ErrorMsg'] === null || action.payload[key]['ErrorMsg'] === "" || action.payload[key]['ErrorMsg'] === undefined) {
              shouldChangegateway = true
              isErrortemp = false
              val['@NodesCount'] = action.payload[key]['d_ServerQty']
              val['@ProcQty'] = action.payload[key]['RecommendedProcQty']
              val['@StorageDiskQty'] = action.payload[key]['RecommendedDriveQty']
              if (action.payload[key]['RecommendedMemory'] !== null) {
                val['@Memory'] = action.payload[key]['RecommendedMemory']
              }
              if (action.payload[key]['RecommendedServer'] !== null) {
                if (type === Constants.NONGPU_) {
                  currentTabObject.NonGPUValue.Drive = action.payload[key]['RecommendedDriveDesc']
                  currentTabObject.NonGPUValue.DriveQty = action.payload[key]['RecommendedDriveQty']
                  currentTabObject.NonGPUValue.Memory = action.payload[key]['RecommendedMemory']
                  currentTabObject.NonGPUValue.Proc = action.payload[key]['RecommendedProc']
                  currentTabObject.NonGPUValue.Server = action.payload[key]['RecommendedServer']
                  currentTabObject.NonGPUValue.ServerQty = action.payload[key]['d_ServerQty']
                  state.HostCount.NonGPUHostCount = action.payload[key]['d_ServerQty']
                }
                if (type === Constants.GPU_) {
                  currentTabObject.GPUValue.Drive = action.payload[key]['RecommendedDriveDesc']
                  currentTabObject.GPUValue.DriveQty = action.payload[key]['RecommendedDriveQty']
                  currentTabObject.GPUValue.Memory = action.payload[key]['RecommendedMemory']
                  currentTabObject.GPUValue.Proc = action.payload[key]['RecommendedProc']
                  currentTabObject.GPUValue.Server = action.payload[key]['RecommendedServer']
                  currentTabObject.GPUValue.ServerQty = action.payload[key]['d_ServerQty']
                  state.HostCount.GPUHostCount = action.payload[key]['d_ServerQty']
                  val['@GPUcount'] = action.payload[key]['RecommendedGPUQty'].toString()
                }
                if (type === Constants.STORAGE_) {
                  currentTabObject.StorageValue.Drive = action.payload[key]['RecommendedDriveDesc']
                  currentTabObject.StorageValue.DriveQty = action.payload[key]['RecommendedDriveQty']
                  currentTabObject.StorageValue.Memory = action.payload[key]['RecommendedMemory']
                  currentTabObject.StorageValue.Proc = action.payload[key]['RecommendedProc']
                  currentTabObject.StorageValue.Server = action.payload[key]['RecommendedServer']
                  currentTabObject.StorageValue.ServerQty = action.payload[key]['d_ServerQty']
                  state.HostCount.StorageHostCount = action.payload[key]['d_ServerQty']
                  if (action.payload[key]['RecommendedHDFSDriveType'] !== null) {
                    val["@TenantDriveType"] = action.payload[key]['RecommendedHDFSDriveType'];
                  }
                }
                val['@NodeDisk'] = action.payload[key]['RecommendedDriveDesc']
                val['@StorageDiskQty'] = action.payload[key]['RecommendedDriveQty']
                val['@Proc'] = action.payload[key]['RecommendedProc']
                val['@ProcFamily'] = action.payload[key]['RecommendedProcFamily']
                val['@ApproxCost'] = action.payload[key]['dApproxCost']

                val['@Name'] = action.payload[key]['RecommendedServer']
                val['@ServerName'] = val['@Name']
                if (action.payload[key]['RecommendedHDFSDrive'] !== null) {
                  val['@TStorageDrive'] = action.payload[key]['RecommendedHDFSDrive']
                  val['@TStorageDriveQty'] = action.payload[key]['RecommendedHDFSDriveQty']
                }
                else {
                  //  val['@TStorageDrive'] ="None"
                  //   val['@TStorageDriveQty'] ="0"
                }
                val['@TStorageDriveQty'] = action.payload[key]['RecommendedHDFSDriveQty']

              } else {
                if (action.payload[key]['RecommendedHDFSDrive'] !== null) {
                  val['@TStorageDrive'] = action.payload[key]['RecommendedHDFSDrive']
                  val['@TStorageDriveQty'] = action.payload[key]['RecommendedHDFSDriveQty']
                }
                else {
                  //val['@TStorageDrive'] ="None"
                  //  val['@TStorageDriveQty'] ="0"
                }
                val['@TStorageDriveQty'] = action.payload[key]['RecommendedHDFSDriveQty']
                val['@StorageDiskQty'] = action.payload[key]['RecommendedDriveQty']
              }
              updatePersistentDriveArray(type, val, action, key);
            }
            else {
              Errormsgtemp = action.payload[key]['ErrorMsg'];
              isErrortemp = true
            }
          }
        }
      });
      workloadtemp = state.workload

      let caltemprst = true
      //  let caltempcount=state.count-1
      // if(state.count-1===0)
      // {
      caltemprst = false;
      updateGateWayDetails(state);
      // }
      return Object.assign({}, state, {
        workload: workloadtemp,
        // GPUValue: GPUvaluetemp,
        // NonGPUValue: NonGPUvaluetemp,
        // StorageValue: StorageValuetemp,
        BlueDataCal: action.payload,
        isLoading: false,
        isCal: caltemprst,
        // count:caltempcount,
        Errormsg: Errormsgtemp,
        isError: isErrortemp,
        changeGateway: shouldChangegateway
      });
    case 'CALCULATEBLUEDATACONFIG_PENDING':
      // let caltemp;
      //caltemp=state.count+1;
      return Object.assign({}, state, {
        isLoading: true,
        isCal: true,
        // count:caltemp
      });
    case 'CALCULATEBLUEDATACONFIGFALSE_PENDING':
      //let caltemp1;
      //caltemp1=state.count+1;
      return Object.assign({}, state, {
        isLoading: true,
        isCal: true,
        // count:caltemp1
      });
    case 'CALCULATEBLUEDATACONFIGFALSE_SUCCESS':
      let hostcount = ''
      state.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Server.filter((val) => {
        for (let key in action.payload) {
          if (key === "NonGPU_Result") {
            type = "NonGPU"
            state.NonGPUValue.TotalVMemory = action.payload[key]['d_TotalVMemory']
            state.NonGPUValue.TotalCore = action.payload[key]['d_TotalVCPU']
            state.NonGPUValue.TotalStorage = action.payload[key]['d_TotalStorage']
            state.HostCount.NonGPUHostCount = action.payload[key]['d_ServerQty']
            if (action.payload[key]['ErrorMsg'] === null || action.payload[key]['ErrorMsg'] === "" || action.payload[key]['ErrorMsg'] === undefined) {
              state.NonGPUValue.ServerQty = action.payload[key]['d_ServerQty'];
            }
            state.NonGPUValue.isCalculated = 'true';
          } else if (key === "GPU_Result") {
            type = "GPU"
            state.GPUValue.TotalVMemory = action.payload[key]['d_TotalVMemory']
            state.GPUValue.TotalCore = action.payload[key]['d_TotalVCPU']
            state.GPUValue.TotalStorage = action.payload[key]['d_TotalStorage']
            state.HostCount.GPUHostCount = action.payload[key]['d_ServerQty']
            let currentTabObject = state.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_);
            updateGPUsCount(action, Constants.TRAINING, key, currentTabObject);

            if (action.payload[key]['ErrorMsg'] === null || action.payload[key]['ErrorMsg'] === "" || action.payload[key]['ErrorMsg'] === undefined) {
              state.GPUValue.ServerQty = action.payload[key]['d_ServerQty'];
            }
            state.GPUValue.isCalculated = 'true';
            //  state. GPUValue.GPUcountperserver=action.payload[key]['RecommendedGPUQty']
          } else if (key === Constants.STORAGE_) {
            type = Constants.STORAGE_;
            state.HostCount.StorageHostCount = action.payload[key]['d_ServerQty'];
            if (action.payload[key]['ErrorMsg'] === null || action.payload[key]['ErrorMsg'] === "" || action.payload[key]['ErrorMsg'] === undefined) {
              state.StorageValue.ServerQty = action.payload[key]['d_ServerQty'];
            }
            state.StorageValue.isCalculated = 'true';
          }

          if (val['@Type'] === type) {
            if (action.payload[key]['ErrorMsg'] === null || action.payload[key]['ErrorMsg'] === "" || action.payload[key]['ErrorMsg'] === undefined) {
              isErrortemp = false
              shouldChangegateway = true
              val['@NodesCount'] = action.payload[key]['d_ServerQty']
              val['@ApproxCost'] = action.payload[key]['dApproxCost']
              val['@ProcQty'] = action.payload[key]['RecommendedProcQty']
              val['@StorageDiskQty'] = action.payload[key]['RecommendedDriveQty']
              if (action.payload[key]['RecommendedMemory'] !== null) {
                val['@Memory'] = action.payload[key]['RecommendedMemory']
              }
              if (action.payload[key]['RecommendedServer'] !== null) {
                if (type === "NonGPU") {
                  state.NonGPUValue.Drive = action.payload[key]['RecommendedDriveDesc']
                  state.NonGPUValue.DriveQty = action.payload[key]['RecommendedDriveQty']
                  state.NonGPUValue.Memory = action.payload[key]['RecommendedMemory']
                  state.NonGPUValue.Proc = action.payload[key]['RecommendedProc']
                  state.NonGPUValue.Server = action.payload[key]['RecommendedServer']
                  state.NonGPUValue.ServerQty = action.payload[key]['d_ServerQty']
                }
                if (type === "GPU") {
                  state.GPUValue.Drive = action.payload[key]['RecommendedDriveDesc']
                  state.GPUValue.DriveQty = action.payload[key]['RecommendedDriveQty']
                  state.GPUValue.Memory = action.payload[key]['RecommendedMemory']
                  state.GPUValue.Proc = action.payload[key]['RecommendedProc']
                  state.GPUValue.Server = action.payload[key]['RecommendedServer']
                  state.GPUValue.ServerQty = action.payload[key]['d_ServerQty']
                  val['@GPUcount'] = action.payload[key]['RecommendedGPUQty'].toString()
                }
                if (type === Constants.STORAGE_) {
                  state.StorageValue.Drive = action.payload[key]['RecommendedDriveDesc'];
                  //state.StorageValue.DriveQty = action.payload[key]['RecommendedDriveQty'];
                  state.StorageValue.Memory = action.payload[key]['RecommendedMemory'];
                  state.StorageValue.Proc = action.payload[key]['RecommendedProc'];
                  state.StorageValue.Server = action.payload[key]['RecommendedServer'];
                  state.StorageValue.ServerQty = action.payload[key]['d_ServerQty'];
                }
                val['@NodeDisk'] = action.payload[key]['RecommendedDriveDesc']
                val['@StorageDiskQty'] = action.payload[key]['RecommendedDriveQty']
                val['@Proc'] = action.payload[key]['RecommendedProc']
                val['@ProcFamily'] = action.payload[key]['RecommendedProcFamily']

                val['@Name'] = action.payload[key]['RecommendedServer']
                val['@ServerName'] = val['@Name'];
                if (action.payload[key]['RecommendedHDFSDrive'] !== null && type !== Constants.STORAGE_) {
                  val['@TStorageDrive'] = action.payload[key]['RecommendedHDFSDrive']
                  val['@TStorageDriveQty'] = action.payload[key]['RecommendedHDFSDriveQty']
                }

              } else {
                if (action.payload[key]['RecommendedHDFSDrive'] !== null && type !== Constants.STORAGE_) {
                  val['@TStorageDrive'] = action.payload[key]['RecommendedHDFSDrive']
                  val['@TStorageDriveQty'] = action.payload[key]['RecommendedHDFSDriveQty']
                }
                else {
                  //val['@TStorageDrive'] ="None"
                  //  val['@TStorageDriveQty'] ="0"
                }
                if (type !== Constants.STORAGE_) {
                  val['@TStorageDriveQty'] = action.payload[key]['RecommendedHDFSDriveQty']
                }
                val['@StorageDiskQty'] = action.payload[key]['RecommendedDriveQty']
              }
              updatePersistentDriveArray(type, val, action, key);
            }
            else {
              Errormsgtemp = action.payload[key]['ErrorMsg'];
              isErrortemp = true
            }
          }
        }
      });
      workloadtemp = state.workload
      GPUvaluetemp = state.GPUValue
      NonGPUvaluetemp = state.NonGPUValue
      StorageValuetemp = state.StorageValue;
      hostcount = state.HostCount
      let caltemprst1 = true
      //  let caltempcount1=state.count-1
      // if(state.count-1===0)
      //   {
      caltemprst1 = false;
      if (state.guiState.computeHostChanged) {
        updateGateWayDetails(state);
      }
      //  }
      return Object.assign({}, state, {
        workload: workloadtemp,
        GPUValue: GPUvaluetemp,
        NonGPUValue: NonGPUvaluetemp,
        StorageValue: StorageValuetemp,
        BlueDataCal: action.payload,
        HostCount: hostcount,
        isLoading: false,
        isCal: caltemprst1,
        //  count:caltempcount1,
        Errormsg: Errormsgtemp,
        isError: isErrortemp,
        changeGateway: shouldChangegateway
      });
    case 'FETCH_GATEWAYDLTS_SUCCESS':
      let Controllertemp = '';
      let Mastertemp = '';
      let GPUtemp = '';
      //let NonGPUtemp = '';
      calculateBlueDataAPIcount = state.calculateBlueDataAPIcount - 1;

      let GPUandNonGPUCommonMethod = (roleId) => {
        let GPUandNonGPUtemp = action.payload.totalList
        //let NonGPUList = NonGPUtemp
        let temp = state.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Server[roleId];
        let Serverlist = [];
        let processortemp = [];
        let processorList = [];
        let processorFamilyList = [];
        for (let key in GPUandNonGPUtemp) {
          Serverlist.push(key);
        }
        if (Serverlist.indexOf(temp['@Name']) === -1) {
          temp['@Name'] = Serverlist[0];
        }

        for (let procfamily in GPUandNonGPUtemp[Serverlist.filter(x => x === temp['@Name'])[0]].ProcessorList) {
          processorFamilyList.push(procfamily)
        }
        if (processorFamilyList.indexOf(temp["@ProcFamily"]) === -1) {
          temp["@ProcFamily"] = processorFamilyList[0];
        }

        processortemp = GPUandNonGPUtemp[Serverlist.filter(x => x === temp['@Name'])[0]].ProcessorList[processorFamilyList.filter(x => x === temp['@ProcFamily'])[0]];

        for (let key in processortemp) {
          processorList.push(key);
        }
        if (processorList.indexOf(temp["@Proc"]) === -1) {
          temp["@Proc"] = processorList[0];
        }
        if (processortemp[Object.keys(processortemp).filter(x => x === temp["@Proc"])[0]].indexOf(temp["@Memory"]) === -1) {
          temp["@Memory"] = processortemp[Object.keys(processortemp).filter(x => x === temp["@Proc"])[0]][0];
        }
        if (GPUandNonGPUtemp[Serverlist.filter(x => x === temp['@Name'])[0]].OSDriveList.indexOf(temp["@OSDisk"]) === -1) {
          temp["@OSDisk"] = GPUandNonGPUtemp[Serverlist.filter(x => x === temp['@Name'])[0]].OSDriveList[0];
        }
        if (GPUandNonGPUtemp[Serverlist.filter(x => x === temp['@Name'])[0]].DataDriveList.indexOf(temp["@NodeDisk"]) === -1) {
          temp["@NodeDisk"] = GPUandNonGPUtemp[Serverlist.filter(x => x === temp['@Name'])[0]].DataDriveList[0];
        }
      }

      if (action.payload.Hosttype === "Gateway") {
        let Gatewaytemp = action.payload.totalList
        let gatewaytemp = true
        let gatewaytempcount = state.count - 1
        if (state.count - 1 === 0) {
          gatewaytemp = false
        }
        return Object.assign({}, state, {
          Gatewaydetails: Gatewaytemp,
          isLoading: gatewaytemp,
          count: gatewaytempcount
        });
      } else if (action.payload.Hosttype === "Controller") {
        Controllertemp = action.payload.totalList
        let controllertemp = true
        let controllertempcount = state.count - 1
        if (state.count - 1 === 0) {
          controllertemp = false
        }
        return Object.assign({}, state, {
          Controllerdetails: Controllertemp,
          isLoading: controllertemp,
          count: controllertempcount
        });
      } else if (action.payload.Hosttype === "Master") {
        Mastertemp = action.payload.totalList
        let mastertemp = true
        let mastertempcount = state.count - 1
        if (state.count - 1 === 0) {
          mastertemp = false
        }
        return Object.assign({}, state, {
          Masterdetails: Mastertemp,
          isLoading: mastertemp,
          count: mastertempcount
        });
      }
      else if (action.payload.Hosttype === "GPU") {
        GPUtemp = action.payload.totalList
        let index = state.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Server.findIndex(role => role["@Type"] === Constants.GPU_);
        if (index !== -1) {
          GPUandNonGPUCommonMethod(index);
        }

        let wl = state.workload;
        let gputemp = true
        let gputempcount = state.count - 1
        if (state.count - 1 === 0) {
          gputemp = false
        }
        return Object.assign({}, state, {
          GPUdetails: GPUtemp,
          workload: wl,
          isLoading: gputemp,
          count: gputempcount,
          calculateBlueDataAPIcount: calculateBlueDataAPIcount
        });
      }
      else if (action.payload.Hosttype === "NonGPU") {

        let NonGPUtemp = action.payload.totalList;
        let index = state.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_).Templates.ServerDetails.Server.findIndex(role => role["@Type"] === Constants.NONGPU_);
        if (index !== -1) {
          GPUandNonGPUCommonMethod(index);
        }

        let wl = state.workload;
        let nongputemp = true
        let nongputempcount = state.count - 1
        if (state.count - 1 === 0) {
          nongputemp = false
        }

        return Object.assign({}, state, {
          NonGPUdetails: NonGPUtemp,
          workload: wl,
          isLoading: nongputemp,
          count: nongputempcount,
          calculateBlueDataAPIcount: calculateBlueDataAPIcount,
        });
      }
      else if (action.payload.Hosttype === Constants.STORAGE_HOST_ROLE_NAME) {
        let countTemp = state.count - 1;
        let loadingTemp = true;
        if (countTemp === 0) {
          loadingTemp = false;
        }
        let storageDetailsTemp = { ...action.payload.totalList };
        return Object.assign({}, state, {
          count: countTemp,
          isLoading: loadingTemp,
          Storagedetails: storageDetailsTemp
        })
      }
    case 'FETCH_GATEWAYDLTS_PENDING':
      let gatetemp;
      gatetemp = state.count + 1;
      return Object.assign({}, state, {
        isLoading: true,
        count: gatetemp
      });

    case 'GETEXTRANODES_QTY_SUCCESS':
      let extraqty = '';
      let quantity;
      state.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        if (val['@Type'] === "Master Node") {
          quantity = action.payload.masterqty;
          val.Service.Recommendation['@NodesCount'] = action.payload.masterqty
          //val.Service.Hardware['@NodesCount'] = action.payload.masterqty
          if (val.Service.Hardware['@NodesQty'] === "Sizer Recommendation") {
            //val.Service.Hardware['@NodesCount'] = action.payload.gatewayqty //CID 10688 (#1 of 1): Copy-paste error, Coverity Fix by Aditya
            val.Service.Hardware['@NodesCount'] = action.payload.masterqty
          }
          updateGrowthItem(val['@Type'], quantity, state.workload);
        }
        if (val['@Type'] === "Gateway Node") {
          quantity = action.payload.gatewayqty;
          val.Service.Recommendation['@NodesCount'] = action.payload.gatewayqty
          if (val.Service.Hardware['@NodesQty'] === "Sizer Recommendation") {
            val.Service.Hardware['@NodesCount'] = action.payload.gatewayqty
          }
          updateGrowthItem(val['@Type'], quantity, state.workload);
        }
      });
      let Savevalues = {
        MasterQTY: action.payload.masterqty,
        GatewayQty: action.payload.gatewayqty
      }

      extraqty = state.workload;
      return Object.assign({}, state, {
        workload: extraqty,
        MasterQTY: action.payload.masterqty,
        GatewayQty: action.payload.gatewayqty,
        prevValues: Savevalues,
        isLoading: false,
        getExtraNodes: false
      });
    case 'GETEXTRANODES_QTY_PENDING':
      return Object.assign({}, state, {
        isLoading: true
      });
    case 'CONTROLLER_CONFIG':
      return Object.assign({}, state, {
        ControllerConfigChanged: action.payload.data,
      });
    case 'ERROR_CLOSE':
      return Object.assign({}, state, {
        isError: false,
        Errormsg: 'error'
      });
    case 'CALC_DISABLED':
      return Object.assign({}, state, {
        calbtn: action.payload.data
      });

    case 'UPDATE_CALCULATEBLUEDATAAPICOUNT':
      return Object.assign({}, state, { calculateBlueDataAPIcount: action.payload })
    case "FETCH_ANALYTICSDATABASENODEQTY_PENDING":
      return Object.assign({}, state, {
        isLoading: true
      });
    case "FETCH_ANALYTICSDATABASENODEQTY_SUCCESS":
      state.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        if (val['@Type'] === action.payload.function) {
          if (Array.isArray(val.Service)) {
            val.Service.filter((service) => {
              if (service['@Type'] === action.payload.service) {
                service.Hardware['@NodesCount'] = action.payload.qty;
              }
            });
          }
        }
      });
      servicetemp = state.workload;
      return Object.assign({}, state, {
        workload: servicetemp,
        isLoading: false
      });
    case 'CHANGE_GATEWAY':
      return Object.assign({}, state, {
        changeGateway: action.payload
      });

    case 'LOAD_SELECTION_SUCCESS':
      if (action.payload.Workload.UserInputs.Environments.WorkloadType === Constants.BLUE_DATA) {
        if (Array.isArray(action.payload.Workload.UserInputs.Environments.Environment)) {
          state.NonGPUValue = { ...action.payload.Workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_).NonGPUValue };
          state.GPUValue = { ...action.payload.Workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === Constants.yES_).GPUValue };
        } else {
          state.NonGPUValue = { ...action.payload.Workload.UserInputs.Environments.GPUValue };
          state.GPUValue = { ...action.payload.Workload.UserInputs.Environments.NonGPUValue };
        }
      }
      let GPUvaluetempo = state.GPUValue;
      let NonGPUvaluetempo = state.NonGPUValue;
      return Object.assign({}, state, {
        GPUValue: GPUvaluetempo,
        NonGPUValue: NonGPUvaluetempo,
      })

    case 'CALCULATE_WITHUPDATEDTENANTDRIVEACTION':
      return Object.assign({}, state, {
        calculateWithUpdatedTenantDrive: action.payload
      });

    case 'CURRENT_ROLENAMEACTION':
      return Object.assign({}, state, {
        currentRoleName: action.payload
      });


    case 'UPDATE_SCREEN':
      return Object.assign({}, state, {
        currentTab: action.payload
      });

    case 'GATEWAY_RECOMMENDATIONS_PENDING':
      return Object.assign({}, state, {
        isLoading: true
      });

    case 'CONTROLLER_RECOMMENDATIONS_PENDING':
      return Object.assign({}, state, {
        isLoading: true
      });

    case 'MASTER_RECOMMENDATIONS_PENDING':
      return Object.assign({}, state, {
        isLoading: true
      });

    case 'GATEWAY_RECOMMENDATIONS_SUCCESS':
      const shouldLoad = updateGatewayandController(state, action, Constants.GATEWAY_);
      workloadtemp = state.workload;
      return Object.assign({}, state, {
        workload: workloadtemp,
        isLoading: shouldLoad,
      })

    case 'CONTROLLER_RECOMMENDATIONS_SUCCESS':
      const shouldload1 = updateGatewayandController(state, action, Constants.CONTROLLER_);
      workloadtemp = state.workload;
      return Object.assign({}, state, {
        workload: workloadtemp,
        isLoading: shouldload1,
      })

    case 'MASTER_RECOMMENDATIONS_SUCCESS':
      const shouldload2 = updateGatewayandController(state, action, Constants.MASTER_);
      workloadtemp = state.workload;
      return Object.assign({}, state, {
        workload: workloadtemp,
        isLoading: shouldload2,
      })

  }

  return state;
};

export default sizerWorkload;



// WEBPACK FOOTER //
// ./src/SizerUI/Redux/reducers/sizerWorkload.js